import { ForSigningComponent } from './for-signing.component';
import { ForSigningListComponent } from './list/forsigning.list.component';
import { ForSigningSingleIndexComponent } from './single-index/forsigning.single.index.component';

import { ForSigningResolver } from '../../../resolves/forsigning.resolver';
import { ForSigningObjectsComponent } from './objects/forsigning.objects.component';

export const ForSigningRoutes: Array<any> = [
  {
    path: 'forsigning',
    component: ForSigningComponent,
    canActivate: [],
    children: [
      {
        path: '',
        component: ForSigningListComponent,
        children: []
      },
      {
        path: ':id',
        component: ForSigningSingleIndexComponent,
        resolve: {
          data: ForSigningResolver
        },
        children: [
          {
            path: '',
            redirectTo: 'objects',
            pathMatch: 'full',
          },
          {
            path: 'objects',
            component: ForSigningObjectsComponent,
          },
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/for-signing.routes.ts